/* eslint-disable react/no-multi-comp */
import React from 'react';

import { Icon } from '@vk-hr-tek/ui/Icon';

import {
  SystemLinkItem,
  SystemDropdownItem,
  SystemSectionItem,
} from '@app/gen/side_menu';

type LinkItemKeys = SystemLinkItem['nick'];
type DropdownItemKeys = SystemDropdownItem['nick'];
type SectionItemKeys = SystemSectionItem['nick'];

type NicknameKeys = LinkItemKeys | DropdownItemKeys | SectionItemKeys;

export const sidebarIcons = (
  isActive?: boolean,
): Record<NicknameKeys, JSX.Element | null> => {
  const color = isActive ? 'text.light.secondary' : 'text.light.primary';

  return {
    main: <Icon name="home_outline" size="20" color={color} />,
    news: <Icon name="advertising_outline" size="20" color={color} />,
    structure: <Icon name="vkhrtek_company_page" size="20" color={color} />,
    company_events: null,
    dropdown_company_events: (
      <Icon name="article_box_outline" size="20" color={color} />
    ),
    company_events_paper: null,
    company_policy: <Icon name="document_outline" size="20" color={color} />,
    company_absences: <Icon name="calendar_outline" size="20" color={color} />,
    company_vacations: (
      <Icon name="vkhrtek_vacations_page" size="20" color={color} />
    ),
    company_employees: <Icon name="users_3_outline" size="20" color={color} />,
    company_candidates: (
      <Icon name="user_square_on_square_outline" size="20" color={color} />
    ),
    employee_personal: (
      <Icon name="user_square_outline" size="20" color={color} />
    ),
    employee_events: (
      <Icon name="article_box_outline" size="20" color={color} />
    ),
    employee_policy: <Icon name="document_outline" size="20" color={color} />,
    employee_absences: <Icon name="calendar_outline" size="20" color={color} />,
    employee_payslips: <Icon name="wallet_outline" size="20" color={color} />,
    employee_vacations: (
      <Icon name="vkhrtek_vacations_page" size="20" color={color} />
    ),
    employee_competencies: (
      <Icon name="user_check_outline" size="20" color={color} />
    ),
    dropdown_company_settings: (
      <Icon name="gear_outline" size="20" color={color} />
    ),
    dropdown_social_services: (
      <Icon name="hand_heart_outline" size="20" color={color} />
    ),
    employee_review: (
      <Icon name="logo_vk_ads_outline" size="20" color={color} />
    ),
    company_review: <Icon name="logo_vk_ads_outline" size="20" color={color} />,
    company_settings: <Icon name="globe_outline" size="20" color={color} />,
    company_settings_event_types: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_templates: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_groups: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_profiles: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_substitutes: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_vacations: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_attorneys: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_attorneys_users: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_settings_sign_types: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_social_news: <Icon name="globe_outline" size="20" color={color} />,
    company_services: <Icon name="globe_outline" size="20" color={color} />,
    employee_services: <Icon name="globe_outline" size="20" color={color} />,
    company_social_categories: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
    company_social_quiz: <Icon name="globe_outline" size="20" color={color} />,
    company_social_access: (
      <Icon name="globe_outline" size="20" color={color} />
    ),
  };
};

export const sidebarCustomIcons = (
  isActive?: boolean,
): Record<string, JSX.Element | null> => {
  const color = isActive ? 'text.light.secondary' : 'text.light.primary';
  return {
    globe: <Icon name="globe_outline" size="20" color={color} />,
    document: <Icon name="document_outline" size="20" color={color} />,
    bookmark: <Icon name="bookmark_outline" size="20" color={color} />,
    picture: <Icon name="picture_outline" size="20" color={color} />,
    cup: <Icon name="cup_outline" size="20" color={color} />,
    briefcase: <Icon name="briefcase_outline" size="20" color={color} />,
    advertising: <Icon name="advertising_outline" size="20" color={color} />,
    user: <Icon name="user_outline" size="20" color={color} />,
  };
};
